import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class BodyCarSlideDisc extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodyCarSlideDiscState: this.props.bodyCarSlideDisc,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {}

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeSlidepriceMax = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_max = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }
      handleChangeSlidepriceMin = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_min = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }

      handleChangeSlideDiscMinPercent = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_minpercent = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }

      handleChangeSlideDiscMinInsalmentPercent = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_instalment_minpercent = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }

      handleChangeSlideDiscMaxPercent = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_maxpercent = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }

      handleChangeSlideDiscMaxInsalmentPercent = (event) => {
            var temparray = this.state.bodyCarSlideDiscState
            temparray.bodycar_slidedisc_instalment_maxpercent = event
            this.setState({ bodyCarSlideDiscState: temparray })
      }
      modifyNewSlideDisc = () => {
            const { bodyCarSlideDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_bodycar_slidedisc")
            fd.append("bodycar_slidedisc_id", bodyCarSlideDiscState.bodycar_slidedisc_id)
            fd.append("bodycar_slidedisc_minpercent", bodyCarSlideDiscState.bodycar_slidedisc_minpercent)
            fd.append("bodycar_slidedisc_instalment_minpercent", bodyCarSlideDiscState.bodycar_slidedisc_instalment_minpercent)
            fd.append("bodycar_slidedisc_maxpercent", bodyCarSlideDiscState.bodycar_slidedisc_maxpercent)
            fd.append("bodycar_slidedisc_instalment_maxpercent", bodyCarSlideDiscState.bodycar_slidedisc_instalment_maxpercent)
            fd.append("bodycar_slidedisc_max", bodyCarSlideDiscState.bodycar_slidedisc_max)
            fd.append("bodycar_slidedisc_min", bodyCarSlideDiscState.bodycar_slidedisc_min)
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteSlideDisc = () => {
            const { bodyCarSlideDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_bodycar_slidedisc")
            fd.append("bodycar_slidedisc_id", bodyCarSlideDiscState.bodycar_slidedisc_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { snackMode, snackstr, showSnack, visible, bodyCarSlideDiscState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="حد پایین"
                                          handleInputt={this.handleChangeSlidepriceMin}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_min}
                                    />
                              </Grid>
                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="currency"
                                          placeholder="حد بالا"
                                          handleInputt={this.handleChangeSlidepriceMax}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_max}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="حداقل تخفیف"
                                          handleInputt={this.handleChangeSlideDiscMinPercent}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_minpercent}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="حداکثر تخفیف"
                                          handleInputt={this.handleChangeSlideDiscMaxPercent}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_maxpercent}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="حداقل تخفیف اقساط"
                                          handleInputt={this.handleChangeSlideDiscMinInsalmentPercent}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_instalment_minpercent}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="حداکثر تخفیف اقساط"
                                          handleInputt={this.handleChangeSlideDiscMaxInsalmentPercent}
                                          value={bodyCarSlideDiscState.bodycar_slidedisc_instalment_maxpercent}
                                    />
                              </Grid>

                              <Grid item xs={2}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewSlideDisc}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteSlideDisc}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(BodyCarSlideDisc)
